// Widgetlar (features/widgets): yuqori panel, panel, soat, ru
export default {
  title: "Виджеты",
  edit: "Изменить",
  done: "Готово",
  add: "Добавить виджет",
  addThis: "Добавить",
  back: "Назад",
  pin: "Закрепить сбоку",
  unpin: "Открепить",
  empty: "Виджетов пока нет",
  emptyHint: "Добавьте мировые часы, чтобы видеть время в США.",
  full: "Не более {{n}} виджетов",
  removed: "{{name}}: удалено",
  undo: "Вернуть",
  removeWidget: "Удалить виджет",
  removeNamed: "Удалить: {{name}}",
  editWidget: "Настроить: {{name}}",
  showTop: "Показывать на верхней панели",
  topFull: "не более {{n}} виджетов",
  sizeLabel: "Размер",
  size: { s: "Малый", m: "Средний", l: "Большой" },
  menu: {
    settings: "Настроить",
    size: "Размер",
    showTop: "Показывать на верхней панели",
    hideTop: "Убрать с верхней панели",
    remove: "Удалить",
  },
  failed: "Не удалось показать виджет.",
  loadFailed: "Не удалось загрузить виджеты.",
  retry: "Повторить",
  conflict: "Виджеты изменены в другом окне. Показаны последние.",
  saveFailed: "Не удалось сохранить виджеты.",
  calendar: {
    title: "Календарь",
    description: "Напоминания, дни выхода на работу, сроки оплат перевозчиков и сроки документов в одном месяце.",
    glance_one: "Сегодня {{count}}",
    glance_few: "Сегодня {{count}}",
    glance_many: "Сегодня {{count}}",
    glance_other: "Сегодня {{count}}",
    today: "Сегодня",
    tomorrow: "Завтра",
    empty: "Ничего не запланировано",
    emptyDay: "В этот день ничего нет",
    prev: "Предыдущий месяц",
    next: "Следующий месяц",
    kindsTitle: "Показывать",
    showDone: "Показывать выполненные напоминания",
    kinds: {
      reminder: "Напоминания",
      start: "Дни выхода / ориентации",
      fee: "Срок оплаты перевозчика",
      expiry: "Сроки документов",
      available: "Водитель свободен с",
      assignment: "Окончание закрепления",
    },
  },
  callnow: {
    title: "Позвонить сейчас",
    description: "Ваши водители, у которых местное время в окне звонков; сначала те, у кого подошло напоминание.",
    now: "можно звонить сейчас",
    reminder: "напоминание",
    never: "ещё не звонили",
    daysAgo_one: "{{count}} день назад",
    daysAgo_few: "{{count}} дня назад",
    daysAgo_many: "{{count}} дней назад",
    daysAgo_other: "{{count}} дня назад",
    empty: "Сейчас звонить некому",
    callHint: "Местное время штата водителя.",
    limit: "Длина списка",
  },
  shift: {
    title: "Смена",
    description: "Сколько осталось в смене и в каких зонах США сейчас рабочее время.",
    left: "осталось",
    ended: "закончилась",
    startsIn: "до начала",
    elapsed: "прошло {{time}}",
    usHours: "Рабочее время в США",
    start: "Начало",
    end: "Конец",
    hint: "В вашем часовом поясе ({{tz}}). Смена может переходить через полночь.",
  },
  goal: {
    title: "Цель месяца",
    description: "Утверждённые наймы за месяц относительно цели, как кольцо активности.",
    hires: "наймов",
    monthTitle: "Этот месяц",
    remaining_one: "До цели ещё {{count}}",
    remaining_few: "До цели ещё {{count}}",
    remaining_many: "До цели ещё {{count}}",
    remaining_other: "До цели ещё {{count}}",
    ahead_one: "На {{count}} впереди графика",
    ahead_few: "На {{count}} впереди графика",
    ahead_many: "На {{count}} впереди графика",
    ahead_other: "На {{count}} впереди графика",
    behind_one: "На {{count}} позади графика",
    behind_few: "На {{count}} позади графика",
    behind_many: "На {{count}} позади графика",
    behind_other: "На {{count}} позади графика",
    onPace: "По графику",
    day: "день {{day}} из {{days}}",
    bonus: "{{amount}} за найм",
    noGoal: "Цель не задана",
    noGoalOwner: "Цель: Настройки → Правило бонуса",
  },
  starts: {
    title: "Ближайшие выходы",
    description: "Водители, выходящие на работу или на ориентации в ближайшие дни, с их местным временем.",
    within: "выходят в ближайшие {{days}} дн.",
    empty: "В ближайшие {{days}} дн. выходов нет",
    daysLabel: "Горизонт",
    days_one: "{{count}} день",
    days_few: "{{count}} дня",
    days_many: "{{count}} дней",
    days_other: "{{count}} дня",
  },
  fees: {
    title: "Оплаты перевозчиков",
    description: "Просроченные и ближайшие оплаты перевозчиков с остатком суммы.",
    overdue_one: "{{count}} просрочена",
    overdue_few: "{{count}} просрочены",
    overdue_many: "{{count}} просрочено",
    overdue_other: "{{count}} просрочено",
    soon_one: "{{count}} в ближайшие {{days}} дн.",
    soon_few: "{{count}} в ближайшие {{days}} дн.",
    soon_many: "{{count}} в ближайшие {{days}} дн.",
    soon_other: "{{count}} в ближайшие {{days}} дн.",
    soonShort: "{{amount}} в ближайшие {{days}} дн. ({{count}})",
    empty: "Нет просроченных и ближайших оплат",
    daysLabel: "Срок в пределах",
  },
  note: {
    title: "Заметка",
    description: "Быстрая заметка во время звонка. Хранится на сервере, видна на всех устройствах.",
    placeholder: "Напишите заметку…",
    empty: "Пустая заметка",
  },
  recent: {
    title: "Недавно открытые",
    description: "Последние водители и перевозчики, открытые на этом устройстве.",
    empty: "Пока ничего не открыто",
  },
  rate: {
    title: "Курс валют",
    description: "USD → UZS по Центральному банку, с данными за 30 дней.",
    usd: "1 USD",
    week: "7 дней",
    cbu: "Центральный банк",
    manual: "задан вручную",
    none: "Курса пока нет",
    days_one: "{{count}} день",
    days_few: "{{count}} дня",
    days_many: "{{count}} дней",
    days_other: "{{count}} дня",
  },
  clock: {
    title: "Мировые часы",
    description: "Часовые пояса США и ваш. В большом размере видно, когда можно звонить.",
    day: { today: "Сегодня", tomorrow: "Завтра", yesterday: "Вчера" },
    hours: "{{value}} ч",
    now: "Сейчас",
    callLegend: "Время звонков {{from}}–{{to}}, местное",
    zones: "Часовые пояса",
    reorder: "Перетащите, чтобы изменить порядок",
    label: "Название для: {{city}}",
    removeZone: "Удалить: {{city}}",
    search: "Город или штат (TX)",
    noResults: "Ничего не найдено",
    addUs: "Пояса США",
    maxZones: "Не более {{n}} часовых поясов.",
    seconds: "Секундная стрелка",
    format: "Формат времени",
    formatAuto: "Авто ({{value}} ч)",
    format24: "24 часа",
    format12: "12 часов",
    callHours: "Время звонков",
    callFrom: "С",
    callTo: "До",
    callHint: "Местное время в каждом поясе; зелёным в большом размере.",
    cities: {
      "America/New_York": "Нью-Йорк",
      "America/Chicago": "Чикаго",
      "America/Denver": "Денвер",
      "America/Phoenix": "Финикс",
      "America/Los_Angeles": "Лос-Анджелес",
      "America/Anchorage": "Анкоридж",
      "Pacific/Honolulu": "Гонолулу",
      "Asia/Tashkent": "Ташкент",
      "Asia/Samarkand": "Самарканд",
      "Europe/Moscow": "Москва",
      "Europe/London": "Лондон",
      "Europe/Istanbul": "Стамбул",
      "Asia/Dubai": "Дубай",
      UTC: "UTC",
    },
  },
};
